<template>
  <section class="mt-14 md:mt-14 w-full min-h-screen bg-subtleGray">
    <!-- header -->
    <div class="relative border-b mt-3 border-gray-300 w-full">
      <div class="p-3 md:p-4 2xl:px-0 w-full max-w-1xl mx-auto">
        <div class="py-2 flex items-start justify-between">
          <div>
            <h1 class="font-bold text-lg md:text-3xl text-gray-800">
              {{
                !$route.query.search
                  ? "Photo"
                  : `Results for “${$route.query.search}”`
              }}
            </h1>

            <h3 class="mt-2 text-xs md:text-sm text-gray-600">
              <!-- 	{{ getCount && getCount.mainCount }} -->
              {{ getCount && getCount.mainCount }} Unlimited Downloads Available
            </h3>
          </div>

          <div
            class="
              pt-2
              hidden
              md:flex
              flex-col
              items-center
              justify-center
              space-x-2
            "
          >
            <div class="flex items-center justify-center">
              <router-link
                to="/all-items"
                class="
                  font-semibold
                  text-xs text-gray-800
                  flex
                  items-center
                  justify-center
                  space-x-1
                "
              >
                <svg
                  class="w-4 h-4 mb-1 text-brandPurple"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"
                  />
                </svg>
                <span class="whitespace-nowrap">All items</span>
              </router-link>

              <svg
                class="text-brandPurple w-4 h-4"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M9 5l7 7-7 7"
                />
              </svg>

              <router-link to="#" class="font-semibold text-xs text-gray-800">
                Stock Footage
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end of header -->

    <div
      class="
        relative
        max-w-1xl
        p-3
        md:p-6
        2xl:px-0
        mx-auto
        pt-3
        transition-width
        w-full
        flex
        items-start
        justify-between
        duration-300
        md:space-x-8
        space-x-3 space-y-3
        md:space-y-0
      "
    >
      <!-- filter -->
      <div
        class="block sticky z-30 top-36 md:top-36 transition-width duration-300"
      >
        <div class="relative block md:static">
          <div class="absolute inset-0 z-30 md:static">
            <div
              :class="filterToggle ? 'w-filterWidth' : 'w-16'"
              class="transition-width duration-300"
            >
              <button
                @click="filterToggle = !filterToggle"
                class="
                  w-full
                  bg-white
                  px-3
                  py-3
                  focus:outline-none
                  flex
                  items-start
                  justify-between
                  rounded-t-md
                "
              >
                <div class="flex items-center space-x-3 justify-center">
                  <svg
                    class="w-5 h-5 text-gray-600"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      d="M5 4a1 1 0 00-2 0v7.268a2 2 0 000 3.464V16a1 1 0 102 0v-1.268a2 2 0 000-3.464V4zM11 4a1 1 0 10-2 0v1.268a2 2 0 000 3.464V16a1 1 0 102 0V8.732a2 2 0 000-3.464V4zM16 3a1 1 0 011 1v7.268a2 2 0 010 3.464V16a1 1 0 11-2 0v-1.268a2 2 0 010-3.464V4a1 1 0 011-1z"
                    />
                  </svg>
                  <Transition
                    enter-active-class="transition duration-300"
                    enter-from-class="opacity-0"
                    enter-to-class="opacity-100"
                    leave-active-class="transition duration-100"
                    leave-from-class="opacity-100"
                    leave-to-class="opacity-0"
                  >
                    <span
                      v-if="filterToggle"
                      class="text-gray-800 font-medium text-sm"
                    >
                      Filters
                    </span>
                  </Transition>
                </div>
                <span>
                  <svg
                    :class="!filterToggle ? 'ml-2 rotate-180' : ''"
                    class="
                      w-5
                      h-5
                      text-gray-600
                      transform
                      transition-transform
                      duration-300
                    "
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                      clip-rule="evenodd"
                    />
                  </svg>
                </span>
              </button>

              <Transition
                enter-active-class="transition duration-300"
                enter-from-class="opacity-0"
                enter-to-class="opacity-100"
                leave-active-class="transition duration-100"
                leave-from-class="opacity-100"
                leave-to-class="opacity-0"
              >
                <div
                  v-if="filterToggle"
                  class="
                    p-3
                    md:h-filter
                    h-96
                    overflow-y-auto overflow-x-hidden
                    bg-white
                    rounded-b-md
                    w-full
                    shadow
                  "
                >
                  <!-- sort by mobile -->
                  <div
                    class="
                      md:hidden
                      mx-auto
                      relative
                      w-40
                      h-10
                      p-1
                      inset-shadow
                      rounded-md
                      transition-all
                      duration-300
                    "
                  >
                    <div
                      :class="
                        selectedSortBy === 'popular'
                          ? 'translate-x-0 ml-1'
                          : 'translate-x-full -ml-1'
                      "
                      class="
                        absolute
                        z-10
                        w-20
                        h-8
                        left-0
                        transform
                        rounded-md
                        bg-white
                        shadow
                        transition-all
                        duration-300
                      "
                    ></div>
                    <div
                      class="
                        absolute
                        inset-0
                        z-20
                        flex
                        items-center
                        justify-center
                      "
                    >
                      <button
                        @click="selectedSortBy = 'popular'"
                        class="
                          w-20
                          focus:outline-none
                          px-3
                          py-2
                          rounded-md
                          bg-transparent
                          text-xxs
                          md:text-xs
                          text-center
                          ml-1
                        "
                        :class="
                          selectedSortBy === 'popular'
                            ? 'text-gray-800'
                            : 'text-gray-500'
                        "
                      >
                        Popular
                      </button>
                      <button
                        @click="selectedSortBy = 'new'"
                        class="
                          w-20
                          focus:outline-none
                          px-3
                          py-2
                          bg-transparent
                          rounded-md
                          text-xxs
                          md:text-xs
                          text-center
                          mr-1
                        "
                        :class="
                          selectedSortBy === 'new'
                            ? 'text-gray-800'
                            : 'text-gray-500'
                        "
                      >
                        New
                      </button>
                    </div>
                  </div>
                  <!--end of sort by mobile -->

                  <!-- filter content -->
                  <div class="mt-1 md:mt-0">
                    <div class="flex items-center justify-between">
                      <h1 class="my-3 text-xs font-bold text-gray-800">
                        Refine by
                      </h1>
                      <button
                        @click="handleCategoryReset"
                        class="mt-1 text-xs focus:outline-none text-brandPurple"
                      >
                        Clear
                      </button>
                    </div>

                    <div class="my-5 w-full border-t border-gray-300"></div>

                    <!-- categories -->
                    <div class="">
                      <div class="flex items-center justify-between">
                        <h1 class="mt-1 text-xs text-gray-600">Orientation</h1>
                      </div>

                      <div
                        v-if="getSubCategories"
                        :class="showMoreCategory ? 'h-full' : 'overflow-hidden'"
                        class="mt-4 flex flex-col space-y-3"
                      >
                        <div
                          v-for="category in getSubCategories.photo"
                          :key="category.id"
                          class="flex items-center justify-between"
                        >
                          <div
                            class="
                              flex
                              items-center
                              flex-col
                              justify-center
                              space-y-2
                            "
                          >
                            <CustomRoundedCheckbox
                              v-on:clicked="
                                handleCategoryChange(
                                  category.name.toLowerCase()
                                )
                              "
                              :lable="category.name"
                              :select="
                                category.name.toLowerCase() ===
                                selectedSubCategory
                                  ? true
                                  : false
                              "
                            />
                          </div>
                          <div
                            v-if="getCount && getCount.subCategory"
                            class="
                              p-1
                              px-2
                              rounded
                              bg-gray-100
                              flex
                              items-center
                              justify-center
                            "
                          >
                            <h1 class="text-xxs font-bold text-gray-700">
                              {{
                                getCount && getCount.subCategory[category.name]
                              }}
                            </h1>
                          </div>
                          <div
                            v-if="!getCount"
                            class="w-6 h-6 rounded bg-gray-100 animate-pulse"
                          ></div>
                        </div>
                      </div>
                      <button
                        v-if="
                          !showMoreCategory &&
                          getSubCategories.photo &&
                          getSubCategories.photo.length > 8
                        "
                        @click="showMoreCategory = true"
                        class="
                          mt-1
                          text-xs
                          focus:outline-none
                          text-indigo-500
                          hover:text-indigo-700
                        "
                      >
                        Show more
                      </button>
                      <button
                        v-if="
                          showMoreCategory &&
                          getSubCategories.photo &&
                          getSubCategories.photo.length > 8
                        "
                        @click="showMoreCategory = false"
                        class="
                          mt-1
                          text-xs
                          focus:outline-none
                          text-indigo-500
                          hover:text-indigo-700
                        "
                      >
                        Show less
                      </button>
                    </div>
                    <!-- end of categories -->

                    <div class="my-5 w-full border-t border-gray-300"></div>

                    <!-- background -->
                    <div class="">
                      <div class="flex items-center justify-between">
                        <h1 class="mt-1 text-xs text-gray-600">Background</h1>
                      </div>
                      <div class="mt-4 flex flex-col space-y-3">
                        <div class="flex items-center justify-between">
                          <div
                            class="
                              flex
                              items-center
                              flex-col
                              justify-center
                              space-y-2
                            "
                          >
                            <CustomRoundedCheckbox
                              v-on:clicked="handleIsolated"
                              lable="Isolated"
                              :select="isolated"
                            />
                          </div>
                          <div
                            v-if="getCount"
                            class="
                              p-1
                              px-2
                              rounded
                              bg-gray-100
                              flex
                              items-center
                              justify-center
                            "
                          ></div>
                        </div>
                      </div>
                      <div class="mt-4 flex flex-col space-y-3">
                        <div class="flex items-center justify-between">
                          <div
                            class="
                              flex
                              items-center
                              flex-col
                              justify-center
                              space-y-2
                            "
                          >
                            <CustomRoundedCheckbox
                              v-on:clicked="handleBlurred"
                              lable="Blurred"
                              :select="blurred"
                            />
                          </div>
                          <div
                            v-if="getCount"
                            class="
                              p-1
                              px-2
                              rounded
                              bg-gray-100
                              flex
                              items-center
                              justify-center
                            "
                          ></div>
                        </div>
                      </div>
                    </div>
                    <!-- end of background -->
                  </div>
                </div>
              </Transition>
            </div>
          </div>
        </div>
      </div>

      <!-- content -->
      <div class="pl-16 md:pl-0 w-full h-full transition-spacing duration-300">
        <div class="hidden md:flex items-center justify-end">
          <div class="shadow rounded-md">
            <div
              class="
                relative
                w-40
                h-10
                p-1
                rounded-md
                transition-all
                duration-300
                inset-shadow
              "
            >
              <div
                :class="
                  selectedSortBy === 'popular'
                    ? 'translate-x-0 ml-1'
                    : 'translate-x-full -ml-1'
                "
                class="
                  absolute
                  z-10
                  w-20
                  h-8
                  left-0
                  transform
                  rounded-md
                  bg-white
                  shadow-md
                  transition-all
                  duration-300
                "
              ></div>
              <div
                class="absolute inset-0 z-10 flex items-center justify-center"
              >
                <button
                  @click="selectedSortBy = 'popular'"
                  class="
                    w-20
                    focus:outline-none
                    px-3
                    py-2
                    rounded-md
                    bg-transparent
                    text-xs text-center
                    ml-1
                  "
                  :class="
                    selectedSortBy === 'popular'
                      ? 'text-gray-800 font-bold'
                      : 'text-gray-500 font-normal'
                  "
                >
                  Popular
                </button>
                <button
                  @click="selectedSortBy = 'new'"
                  class="
                    w-20
                    focus:outline-none
                    px-3
                    py-2
                    bg-transparent
                    rounded-md
                    text-xs text-center
                    mr-1
                  "
                  :class="
                    selectedSortBy === 'new'
                      ? 'text-gray-800 font-bold'
                      : 'text-gray-500 font-normal'
                  "
                >
                  New
                </button>
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="noResult"
          class="
            mt-20
            h-full
            w-full
            flex
            md:items-start
            items-center
            gap-10
            md:flex-row
            flex-col
            justify-center
          "
        >
          <div class="w-full max-w-xs">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              data-name="Layer 1"
              viewBox="0 0 578.0013 621.92557"
            >
              <path
                fill="#f2f2f2"
                d="M366.64306 352.86002l-249.84894 64.339a33.03735 33.03735 0 01-40.18683-23.728L1.04639 100.04378a33.03734 33.03734 0 0123.728-40.18683L257.21802.00004l59.49463 26.63379 73.65843 286.03936a33.03734 33.03734 0 01-23.72802 40.18683z"
              />
              <path
                fill="#fff"
                d="M27.14338 69.05678a23.52653 23.52653 0 00-16.89723 28.61789l75.5609 293.42725a23.52654 23.52654 0 0028.6179 16.89723l249.84894-64.339a23.52654 23.52654 0 0016.89723-28.61789l-72.51713-281.6073-52.285-23.40643z"
              />
              <path
                fill="#f2f2f2"
                d="M316.07784 28.1475l-38.66749 9.95733a10.99077 10.99077 0 01-13.38436-7.9027l-7.35434-28.55927a.68692.68692 0 01.944-.7991l58.56966 26.01073a.68692.68692 0 01-.10747 1.29301z"
              />
              <path
                fill="#ccc"
                d="M295.73503 278.72811L181.9823 308.02078a5.4953817 5.4953817 0 01-2.74083-10.64353l113.75273-29.29267a5.4953817 5.4953817 0 112.74083 10.64353zM322.31247 291.03611l-135.705 34.9456a5.49538045 5.49538045 0 01-2.74082-10.64353l135.705-34.94561a5.49539 5.49539 0 012.74084 10.64354z"
              />
              <circle
                cx="135.55495"
                cy="323.87767"
                r="19.42315"
                fill="#e6e6e6"
                data-name="Ellipse 44"
              />
              <path
                fill="#fff"
                d="M283.63984 227.89639L132.5649 266.78548a17.01917 17.01917 0 01-20.70125-12.22539l-31.6597-122.9905a17.01916 17.01916 0 0112.22538-20.7012l151.075-38.88909a17.01916 17.01916 0 0120.7012 12.22539l31.65971 122.9905a17.01917 17.01917 0 01-12.2254 20.7012z"
              />
              <path
                fill="#e6e6e6"
                d="M283.63984 227.89639L132.5649 266.78548a17.01917 17.01917 0 01-20.70125-12.22539l-31.6597-122.9905a17.01916 17.01916 0 0112.22538-20.7012l151.075-38.88909a17.01916 17.01916 0 0120.7012 12.22539l31.65971 122.9905a17.01917 17.01917 0 01-12.2254 20.7012zM92.92795 112.80524a15.017 15.017 0 00-10.7871 18.26578l31.6597 122.9905a15.017 15.017 0 0018.26577 10.7871l151.075-38.88908a15.017 15.017 0 0010.7871-18.26578l-31.65977-122.9905a15.017 15.017 0 00-18.26578-10.7871z"
              />
              <path
                fill="#f2f2f2"
                d="M235.83999 113.33353l-76.24555 19.62681a2.73087 2.73087 0 01-3.30848-1.71854 2.63064 2.63064 0 011.85283-3.33925l77.61329-19.97889c3.13521 1.58858 2.31023 4.83781.087 5.41011z"
                data-name="Path 411"
              />
              <path
                fill="#f2f2f2"
                d="M239.28265 126.70752l-76.24555 19.62681a2.73089 2.73089 0 01-3.30845-1.71855 2.63065 2.63065 0 011.85284-3.33925l77.61329-19.97889c3.13521 1.58858 2.31022 4.83781.087 5.41011z"
                data-name="Path 412"
              />
              <path
                fill="#e6e6e6"
                d="M148.51477 158.19195l-23.2694 5.98992a2.962 2.962 0 01-3.60325-2.12795l-7.06858-27.45979a2.962 2.962 0 012.12794-3.60325l23.2694-5.98991a2.963 2.963 0 013.60325 2.12795l7.06859 27.45982a2.962 2.962 0 01-2.12795 3.60324z"
                data-name="Path 413"
              />
              <path
                fill="#f2f2f2"
                d="M246.10979 154.14792l-116.36468 29.95411a2.73087 2.73087 0 01-3.30847-1.71854 2.63062 2.63062 0 011.85284-3.33925l117.73335-30.30646c3.13521 1.58859 2.31022 4.83781.087 5.41012z"
                data-name="Path 414"
              />
              <path
                fill="#f2f2f2"
                d="M249.55348 167.52578l-116.36469 29.95415a2.73086 2.73086 0 01-3.30846-1.71854 2.63061 2.63061 0 011.85283-3.33926l117.73335-30.30643c3.13521 1.58858 2.31022 4.83781.087 5.41011z"
                data-name="Path 415"
              />
              <path
                fill="#f2f2f2"
                d="M252.99491 180.89496l-116.36469 29.95412a2.73086 2.73086 0 01-3.30846-1.71854 2.63061 2.63061 0 011.85283-3.33926l117.73335-30.30643c3.13521 1.58858 2.31023 4.83781.087 5.41011z"
                data-name="Path 416"
              />
              <path
                fill="#f2f2f2"
                d="M256.43833 194.27186l-116.36468 29.95412a2.73087 2.73087 0 01-3.30847-1.71854 2.63063 2.63063 0 011.85284-3.33926l117.73335-30.3064c3.13521 1.58858 2.31022 4.83781.087 5.41011z"
                data-name="Path 417"
              />
              <path
                fill="#f2f2f2"
                d="M259.88002 207.64202l-116.36468 29.95412a2.73088 2.73088 0 01-3.30847-1.71855 2.63062 2.63062 0 011.85284-3.33925l117.73335-30.30643c3.13521 1.58858 2.31022 4.83781.087 5.41011z"
                data-name="Path 418"
              />
              <path
                fill="#fff"
                d="M136.98793 330.68613a2.01449 2.01449 0 01-1.27407-.08782l-.02505-.01034-5.29126-2.24319a2.02852 2.02852 0 111.58747-3.73356l3.42865 1.45835 4.49293-10.56929a2.02766 2.02766 0 012.65942-1.07259l.00068.00028-.027.06912.02812-.06941a2.03011 2.03011 0 011.0723 2.66008l-5.28586 12.42716a2.02886 2.02886 0 01-1.36522 1.16845z"
                data-name="Path 395"
              />
              <path
                fill="#e6e6e6"
                d="M462.47522 464.67753h-258a33.03734 33.03734 0 01-33-33v-303a33.03734 33.03734 0 0133-33h240.02685l50.97315 40.62891v295.37109a33.03734 33.03734 0 01-33 33z"
              />
              <path
                fill="#fff"
                d="M204.47511 105.17753a23.52654 23.52654 0 00-23.5 23.5v303a23.52653 23.52653 0 0023.5 23.5h258a23.52653 23.52653 0 0023.5-23.5V140.8831l-44.79614-35.70557z"
              />
              <path
                fill="#6c63ff"
                d="M412.29421 193.28178H294.83042a5.49538 5.49538 0 010-10.99076h117.46379a5.49538 5.49538 0 110 10.99076zM434.96265 211.82872H294.83042a5.49539 5.49539 0 010-10.99077h140.13223a5.49539 5.49539 0 110 10.99077z"
              />
              <path
                fill="#ccc"
                d="M412.2949 265.40555h-117.46a5.495 5.495 0 100 10.99h117.46a5.495 5.495 0 000-10.99zM434.96482 283.95559H294.83494a5.495 5.495 0 100 10.99h140.12988a5.495 5.495 0 000-10.99zM412.29421 359.51711H294.83042a5.49538 5.49538 0 010-10.99076h117.46379a5.49538 5.49538 0 110 10.99076zM434.96265 378.06403H294.83042a5.49539 5.49539 0 010-10.99077h140.13223a5.49539 5.49539 0 110 10.99077z"
              />
              <circle
                cx="245.91553"
                cy="197.05988"
                r="19.42315"
                fill="#6c63ff"
                data-name="Ellipse 44"
              />
              <path
                fill="#fff"
                d="M243.9908 204.46923a2.0144 2.0144 0 01-1.21191-.40277l-.02168-.01626-4.5647-3.49185a2.02852 2.02852 0 112.46838-3.21972l2.95665 2.26729 6.98671-9.11494a2.02767 2.02767 0 012.84288-.3755l.00058.00044-.04336.06021.04454-.06021a2.03011 2.03011 0 01.37507 2.84345l-8.2179 10.71637a2.02892 2.02892 0 01-1.61348.79109z"
                data-name="Path 395"
              />
              <path
                fill="#ccc"
                d="M267.33494 280.17556a19.42256 19.42256 0 01-19.41992 19.43 4.17626 4.17626 0 01-.5-.02 19.422 19.422 0 1119.91992-19.41z"
              />
              <circle
                cx="245.91553"
                cy="363.29519"
                r="19.42315"
                fill="#ccc"
                data-name="Ellipse 44"
              />
              <path
                fill="#ccc"
                d="M494.48299 137.61399h-39.929a10.99077 10.99077 0 01-10.99076-10.99077v-29.491a.68692.68692 0 011.11347-.53844l50.23281 39.79483a.68692.68692 0 01-.42652 1.22538z"
              />
              <path
                fill="#6c63ff"
                d="M267.33494 280.17556a19.42256 19.42256 0 01-19.41992 19.43 4.17626 4.17626 0 01-.5-.02 42.05076 42.05076 0 013.77-38.56 19.43323 19.43323 0 0116.14992 19.15zM289.33494 270.90555a5.50988 5.50988 0 015.5-5.5h29.27a41.57257 41.57257 0 013.60986 10.99h-32.87986a5.50129 5.50129 0 01-5.5-5.49zM328.395 283.95559a41.92449 41.92449 0 01-1.46 10.99h-32.1001a5.495 5.495 0 110-10.99z"
              />
              <path
                fill="#3f3d56"
                d="M400.81665 351.73299a6.00013 6.00013 0 01-8.24672 1.9979l-70.0049-42.70029a6.0000024 6.0000024 0 016.24883-10.24462l70.00489 42.70029a6.00014 6.00014 0 011.9979 8.24672z"
              />
              <path
                fill="#3f3d56"
                d="M330.81175 309.0327a48 48 0 11-15.98318-65.97376 48.05436 48.05436 0 0115.98318 65.97376zm-71.71233-43.74176a36 36 0 1049.48033-11.98738 36.04071 36.04071 0 00-49.48033 11.98738z"
              />
              <circle
                cx="484.60301"
                cy="267.17256"
                r="24.56103"
                fill="#a0616a"
              />
              <path
                fill="#a0616a"
                d="M483.01565 404.86397a11.002 11.002 0 018.32251-14.15136 10.46752 10.46752 0 011.45923-.17969l25.87158-41.52344-23.63232-22.46679a9.43208 9.43208 0 1113.1206-13.55274l32.6294 32.17383.06567.08008a8.54468 8.54468 0 01-.59448 10.18457l-36.25 42.873a10.301 10.301 0 01.27 1.0459 11.0026 11.0026 0 01-9.875 13.11621q-.46839.041-.93213.041a11.0367 11.0367 0 01-10.45506-7.64057zM444.151 609.001l-12.26-.001-5.832-47.288 18.094.001-.002 47.288z"
              />
              <path
                fill="#2f2e41"
                d="M447.27735 620.88486l-39.53051-.00146v-.5a15.38605 15.38605 0 0115.38647-15.38623h.001l24.1438.001z"
              />
              <path
                fill="#a0616a"
                d="M566.007 592.05l-10.534 6.272-29.205-37.646 15.547-9.257 24.192 40.631z"
              />
              <path
                fill="#2f2e41"
                d="M574.77303 600.66156l-33.96586 20.2233-.25581-.4296a15.386 15.386 0 015.34836-21.09206l.00084-.0005 20.74515-12.35158zM424.51265 588.1755c-8.21289-96.70606-13.09863-186.54492 16.92408-223.19336l.23217-.28418 50.52564 20.21094.08325.18066c.17041.37109 16.97388 37.333 13.0542 62.19434l12.46266 57.32812 40.63574 68.041a4.50136 4.50136 0 01-2.05074 6.42776l-17.65918 7.76953a4.52142 4.52142 0 01-5.64844-1.76562l-44.2041-72.08008-24.96778-55.28613a1.50028 1.50028 0 00-2.85888.459l-13.8401 130.09665a4.4918 4.4918 0 01-4.47461 4.02441h-13.72827a4.53045 4.53045 0 01-4.48564-4.12304z"
              />
              <path
                fill="#6c63ff"
                d="M441.60693 365.74878l-.24072-.11523-.0376-.26465c-1.88745-13.21.34668-27.8877 6.63989-43.625a34.63634 34.63634 0 0140.20191-20.74317 34.59441 34.59441 0 0122.06055 16.96387 34.2209 34.2209 0 012.3728 27.4248c-7.93384 23.2002-18.22583 44.90723-18.32886 45.124l-.21558.45312z"
              />
              <path
                fill="#a0616a"
                d="M386.48086 332.84529a11.002 11.002 0 0116.16979 2.83982 10.46856 10.46856 0 01.67932 1.3039l47.95411 9.69217 12.7683-30.00357a9.43208 9.43208 0 1117.28928 7.54372l-18.71 41.83025-.052.08956a8.54469 8.54469 0 01-9.74785 3.00972l-52.8527-18.94078a10.30273 10.30273 0 01-.88511.61918 11.00261 11.00261 0 01-15.74382-4.6565q-.20244-.42436-.36484-.85874a11.0367 11.0367 0 013.49552-12.46873z"
              />
              <path
                fill="#2f2e41"
                d="M573.33152 293.47525c-2.36572-4.19178-5.8125-8.03119-10.36914-9.58069-5.88476-2.001-12.25683.12964-18.30713 1.55218-4.66162 1.09595-9.53173 1.76679-14.23046.84192-4.69825-.92492-9.23047-3.65924-11.36817-7.94409-3.145-6.30359-.4956-13.82062-.687-20.86255a25.33438 25.33438 0 00-31.92334-23.81061c-5.79346-1.67193-11.03906-1.82659-14.62256 2.62714a17.0001 17.0001 0 00-17 17h16.25537a16.1496 16.1496 0 002.4541 11.93109c2.86963 4.21582 7.85938 7.2655 8.81983 12.274.93115 4.85351-2.36817 9.45868-5.8291 12.98669-3.46045 3.528-7.4751 7.02381-8.55567 11.84626a14.68871 14.68871 0 002.10352 10.56475 34.40329 34.40329 0 007.38623 8.13575 108.40184 108.40184 0 0045.0376 23.04034c11.7041 2.81781 24.50586 3.54822 35.37109-1.6355a35.12563 35.12563 0 0015.46484-48.96667z"
              />
              <path
                fill="#ccc"
                d="M577.0013 621.92556h-190a1 1 0 010-2h190a1 1 0 010 2z"
              />
            </svg>
          </div>

          <div class="">
            <h1
              v-if="$route.query.search"
              class="
                font-medium
                text-base
                max-w-md
                block
                text-gray-800 text-left
              "
            >
              We couldn't find a match for “{{ $route.query.search }}”.<br />
              Please try another search
            </h1>
            <h1
              v-else
              class="
                font-medium
                text-base
                max-w-md
                block
                text-gray-800 text-left
              "
            >
              We couldn't find a match
            </h1>

            <ul
              v-if="$route.query.search"
              class="mt-5 text-xs text-gray-600 italic list-disc list-inside"
            >
              <li>Check the spelling of your keyword</li>
              <li>Try alternate words of selection</li>
              <li>Try entering more generic keyword</li>
              <li>Try entering fewer keywords</li>
            </ul>
            <ul
              v-else
              class="mt-5 text-xs text-gray-600 italic list-disc list-inside"
            >
              <li>Try reducing filters</li>
            </ul>
          </div>
        </div>

        <div
          v-if="getProducts && getProducts.length > 0"
          class="
            md:mt-8
            h-full
            grid grid-cols-1
            md:grid-cols-2
            xl:grid-cols-3
            gap-8
            bg-subtleGray
          "
        >
          <div v-for="card in getProducts" :key="card">
            <ProductVideoCard
              :id="card.id"
              :thumbnail="card.thumbnailUrl"
              :video="card.previewUrl"
              :author="card.user.userName"
              :authorId="card.user.id"
              :title="card.productName"
              :date="card.updatedAt.split('T')[0]"
            />
          </div>
        </div>

        <div class="hidden md:block py-16 w-full">
          <Pagination
            v-if="getProducts && getProducts.length > 0"
            class=""
            type="half"
            :pages="getCurrentPage"
            :selected="selectedPage"
            v-on:currentPage="handleCurrentPageChange($event)"
          />
        </div>
      </div>
    </div>
    <div class="py-16 md:hidden">
      <Pagination
        v-if="getProducts && getProducts.length > 0"
        class="md:hidden"
        type="half"
        :pages="getCurrentPage"
        :selected="selectedPage"
        v-on:currentPage="handleCurrentPageChange($event)"
      />
    </div>
  </section>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import RangeSlider from "../components/inputs/RangeSlider.vue";
import VerticalSwitch from "../components/inputs/VerticalSwitch.vue";
import CustomRoundedCheckbox from "../components/utils/CustomRoundedCheckbox.vue";
import Pagination from "../components/utils/Pagination.vue";
import ProductVideoCard from "../components/utils/ProductVideoCard.vue";
import Time from "../components/utils/Time.vue";
export default {
  name: "photo",
  components: {
    Pagination,
    ProductVideoCard,
    VerticalSwitch,
    CustomRoundedCheckbox,
    Time,
    RangeSlider,
  },
  computed: {
    ...mapGetters(["getSubCategories"]),
    ...mapGetters(["getCategories"]),
    ...mapGetters(["getProducts"]),
    ...mapGetters(["getCurrentPage"]),
    ...mapGetters(["getTotalPages"]),
    ...mapGetters(["getCount"]),
    ...mapGetters(["getAllItems"]),
    ...mapGetters(["getAllItemsCount"]),
    ...mapGetters(["getFrameRates"]),
  },

  created() {
    const path = this.$route.path.split("/");

    let subCategory = "";

    let looped = "";

    let alphaChannel = "";

    let sort = "";

    let search = "";

    let minLength = "";

    let maxLength = "";

    let frameRate = "";

    let blurred = "";

    let isolated = "";

    let page = "";

    if (path[2]) {
      subCategory = this.getSubCategories.photo.filter(
        (cat) =>
          cat.name.toLowerCase() === path[2].toLowerCase().split("-").join(" ")
      );

      if (subCategory.length > 0) {
        subCategory = subCategory[0].name.toLowerCase().split(" ").join("-");
        this.selectedSubCategory = subCategory.split("-").join(" ");
      } else {
        subCategory = "";
      }

      sort = path
        .map((v) => v.match(/^sort-by/))
        .filter((data) => data !== null)[0];

      looped = path
        .map((v) => v.match(/^propertise-looped/))
        .filter((data) => data !== null)[0];

      alphaChannel = path
        .map((v) => v.match(/^propertise-alpha-channel/))
        .filter((data) => data !== null)[0];

      frameRate = path
        .map((v) => v.match(/^frame-rate-/))
        .filter((data) => data !== null)[0];

      minLength = path
        .map((v) => v.match(/^minimum-length/))
        .filter((data) => data !== null)[0];

      maxLength = path
        .map((v) => v.match(/^maximum-length/))
        .filter((data) => data !== null)[0];

      blurred = path
        .map((v) => v.match(/^background-blurred/))
        .filter((data) => data !== null)[0];

      isolated = path
        .map((v) => v.match(/^background-isolated/))
        .filter((data) => data !== null)[0];

      page = path
        .map((v, i) => v.match(/^pg-/))
        .filter((data) => data !== null)[0];

      if (sort) {
        sort = sort.input;
      } else {
        sort = "";
      }

      if (looped) {
        looped = looped.input;
      } else {
        looped = "";
      }

      if (frameRate) {
        frameRate = frameRate.input;
      } else {
        frameRate = "";
      }

      if (alphaChannel) {
        alphaChannel = alphaChannel.input;
      } else {
        alphaChannel = "";
      }

      if (isolated) {
        isolated = isolated.input;
      } else {
        isolated = "";
      }

      if (blurred) {
        blurred = blurred.input;
      } else {
        blurred = "";
      }

      if (minLength && maxLength) {
        minLength = minLength.input;
        maxLength = maxLength.input;
      } else {
        minLength = "";
        maxLength = "";
      }

      if (page && page.input !== "pg-1") {
        page = page.input;
      } else {
        page = "";
      }
    }

    this.$router.push({
      name: "photo",
      params: {
        page,
        subCategory,
        search,
        sort,
        looped,
        alphaChannel,
        minLength,
        frameRate,
        maxLength,
        isolated,
        blurred,
      },
      query: { ...this.$route.query },
      hash: this.$route.hash,
    });

    setTimeout(() => {
      this.handleFetchProducts();
    }, 100);
  },

  mounted() {
    if (window.innerWidth < 768) {
      this.filterToggle = false;
    }
  },

  methods: {
    ...mapActions(["fetchProducts"]),

    handleFrameRateChange(e) {
      if (this.selectedFrameRate.includes(e)) {
        this.selectedFrameRate = this.selectedFrameRate.filter(
          (p) => p.toLowerCase() !== e.toLowerCase()
        );
      } else {
        let temp = [...this.selectedFrameRate];
        temp.push(e);
        this.selectedFrameRate = temp;
      }
    },

    handleAudioLengthReleased() {
      const min = this.minimumLength;
      const max = this.maximumLength;
      this.$router.push({
        name: "photo",
        params: {
          ...this.$route.params,
          minLength: `minimum-length-${min}`,
          maxLength: `maximum-length-${max}`,
        },
        query: {
          ...this.$route.query,
        },
        hash: this.$route.hash,
      });
    },

    handleAudioLengthMin(e) {
      this.minimumLength = e;
    },

    handleAudioLengthMax(e) {
      this.maximumLength = e;
    },

    handleAlphaChannel() {
      this.alphaChannel = !this.alphaChannel;
    },

    handleLooped() {
      this.looped = !this.looped;
    },

    handleBlurred() {
      this.blurred = !this.blurred;
    },

    handleIsolated() {
      this.isolated = !this.isolated;
    },

    handleCategoryReset() {
      this.$router.push("/photo");

      setTimeout(() => {
        this.selectedSubCategory = "";
      }, 100);
    },

    handleCurrentPageChange(e) {
      if (e > 1) {
        this.selectedPage = e;
        const formattedPage = `pg-${e}`;
        this.$router.push({
          name: "photo",
          params: { ...this.$route.params, page: formattedPage },
          query: { ...this.$route.query },
          hash: this.$route.hash,
        });
      } else {
        this.$router.push({
          name: "photo",
          params: { ...this.$route.params, page: "" },
          query: { ...this.$route.query },
          hash: this.$route.hash,
        });
      }
    },

    handleFetchProducts() {
      const category = "photo";
      let subCategory = "All";
      let search = null;
      let resolution = null;
      let alphaChannel = null;
      let looped = null;
      let sortBy = null;
      let page = 1;
      let minLength = null;
      let maxLength = null;
      let frameRate = null;
      let isolated = null;
      let blurred = null;

      if (this.$route.params.subCategory) {
        subCategory = this.$route.params.subCategory.split("-").join(" ");
      }

      if (this.$route.params.resolution) {
        resolution = this.$route.params.resolution.split("resolution-")[1];
      }

      if (this.$route.query.search) {
        search = this.$route.query.search;
      }

      if (this.$route.params.minLength && this.$route.params.maxLength) {
        minLength = this.$route.params.minLength.split("minimum-length-")[1];
        this.minimumLength = minLength;
        const min = parseInt(minLength.split(":")[0]);
        const sec = parseInt(minLength.split(":")[1]);
        const length = min * 60 + sec;
        if (length >= 0 && length <= 300) {
          this.min = length;
          this.rangeKey += 1;
        } else {
          this.min = 0;
          this.rangeKey += 1;
        }
      } else {
        this.min = 0;
        this.rangeKey += 1;
      }

      if (this.$route.params.maxLength) {
        maxLength = this.$route.params.maxLength.split("maximum-length-")[1];
        this.maximumLength = maxLength;
        const min = parseInt(maxLength.split(":")[0]);
        const sec = parseInt(maxLength.split(":")[1]);
        const length = min * 60 + sec;

        if (length >= 0 && length <= 330) {
          this.max = length;
          this.rangeKey += 1;
        } else {
          this.max = 330;
          this.rangeKey += 1;
        }
      } else {
        this.max = 330;
        this.rangeKey += 1;
      }

      if (this.$route.params.looped === "propertise-looped") {
        looped = true;
      } else {
        looped = null;
      }

      if (this.$route.params.background === "background-isolated") {
        isolated = true;
      } else {
        isolated = null;
      }

      if (this.$route.params.background === "background-blurred") {
        blurred = true;
      } else {
        blurred = null;
      }

      if (this.$route.params.frameRate) {
        frameRate = this.$route.params.frameRate
          .split("frame-rate-")[1]
          .split(",")
          .map((v) => v.split("-").join(" "))
          .join(",");

        this.selectedFrameRate = frameRate.split(",");
      } else {
        this.selectedFrameRate = [];
      }

      if (this.$route.params.alphaChannel) {
        alphaChannel = true;
      } else {
        alphaChannel = null;
      }

      if (this.$route.params.sort) {
        sortBy = this.$route.params.sort.split("sort-by-")[1];
        this.selectedSortBy = sortBy;
      } else {
        this.selectedSortBy = "popular";
      }

      if (this.$route.params.page) {
        page = parseInt(this.$route.params.page.split("pg-")[1]);
        if (isNaN(page)) {
          page = 1;
        }
        this.selectedPage = page;
      }

      this.fetchProducts({
        category,
        subCategory,
        search,
        looped,
        resolution,
        alphaChannel,
        minLength,
        maxLength,
        frameRate,
        page,
        sortBy,
        isolated,
        blurred,
      });
    },

    handleCategoryChange(type) {
      this.selectedSubCategory = type;
    },

    handleMinimumResolutionChange(type) {
      let temp = this.minimumResolution;
      let array = ["hd", "uhd", "fullHd", "twoK"];
      let outputArray = [];
      const mapArray = {
        hd: "720p (HD)",
        uhd: "4K (UHD)",
        twoK: "2K",
        fullHd: "1080p (Full HD)",
      };
      if (type === "all") {
        temp.all = !temp.all;
        temp.all = temp.all;
        temp.hd = temp.all;
        temp.uhd = temp.all;
        temp.twoK = temp.all;
        temp.fullHd = temp.all;
        if (!temp.all) {
          temp.hd = true;
          outputArray.push(mapArray["hd"]);
          this.selectedResolution = outputArray;
        }
        this.minimumResolution = temp;
      } else {
        temp.all = false;
        temp[type] = !temp[type];
        this.minimumResolution = temp;
        array.forEach((v) => {
          if (temp[v]) {
            outputArray.push(mapArray[v]);
          } else {
            outputArray.filter((t) => t !== mapArray[v]);
          }
        });
        this.selectedResolution = outputArray;
      }

      if (temp.hd && temp.uhd && temp.twoK && temp.fullHd) {
        temp.all = true;
        this.minimumResolution = temp;
        outputArray = ["720p (HD)", "2K", "4K (UHD)", "1080p (Full HD)"];
        this.selectedResolution = outputArray;
      }

      setTimeout(() => {
        if (!temp.hd && !temp.uhd && !temp.twoK && !temp.fullHd) {
          temp.all = true;
          temp.hd = true;
          temp.uhd = true;
          temp.twoK = true;
          temp.fullHd = true;
          this.minimumResolution = temp;
          outputArray = ["720p (HD)", "2K", "4K (UHD)", "1080p (Full HD)"];
          this.selectedResolution = outputArray;
        }
      }, 100);
    },
  },

  data() {
    return {
      searchQuery: "",

      looped: false,

      blurred: false,

      isolated: false,

      alphaChannel: false,

      currentCategory: [],

      filterCategoryType: "",

      selectedSortBy: "popular",

      selectedResolution: ["720p (HD)", "2K", "4K (UHD)", "1080p (Full HD)"],

      minimumResolution: {
        all: true,
        hd: true,
        fullHd: true,
        twoK: true,
        uhd: true,
      },

      selectedFrameRate: [],

      selectedSubCategory: "",

      step: 10,

      selectedPage: 1,

      showMoreCategory: false,

      title: "",

      sortBy: [
        {
          id: 1,
          name: "Sort by popular",
          unavailable: false,
        },
        {
          id: 2,
          name: "New",
          unavailable: false,
        },
      ],

      filterToggle: true,

      min: 0,
      max: 330,
      sliderShow: true,
      endPage: 0,
      minimumLength: "0:00",
      maximumLength: "Any",
      rangeKey: 0,

      noResult: false,
    };
  },

  watch: {
    getCount: function (nv) {
      if (nv.mainCount <= 0) {
        this.noResult = true;
      } else {
        this.noResult = false;
      }
    },
    selectedFrameRate: function (nv, ov) {
      const frameRate = nv.map((v) => v.split(" ").join("-")).join(",");

      if (frameRate.length > 0) {
        this.$router.push({
          name: "photo",
          params: {
            ...this.$route.params,
            frameRate: `frame-rate-${frameRate}`,
          },
          query: { ...this.$route.query },
          hash: this.$route.hash,
        });
      } else {
        this.$router.push({
          name: "photo",
          params: { ...this.$route.params, frameRate: "" },
          query: { ...this.$route.query },
          hash: this.$route.hash,
        });
      }
    },

    alphaChannel: function (nv, ov) {
      if (nv) {
        this.$router.push({
          name: "photo",
          params: {
            ...this.$route.params,
            alphaChannel: `propertise-alpha-channel`,
          },
          query: { ...this.$route.query },
          hash: this.$route.hash,
        });
      } else {
        this.$router.push({
          name: "photo",
          params: { ...this.$route.params, alphaChannel: "" },
          query: { ...this.$route.query },
          hash: this.$route.hash,
        });
      }
    },

    looped: function (nv, ov) {
      if (nv) {
        this.$router.push({
          name: "photo",
          params: { ...this.$route.params, looped: `propertise-looped` },
          query: { ...this.$route.query },
          hash: this.$route.hash,
        });
      } else {
        this.$router.push({
          name: "photo",
          params: { ...this.$route.params, looped: "" },
          query: { ...this.$route.query },
          hash: this.$route.hash,
        });
      }
    },

    blurred: function (nv, ov) {
      if (nv) {
        this.$router.push({
          name: "photo",
          params: { ...this.$route.params, background: `background-blurred` },
          query: { ...this.$route.query },
          hash: this.$route.hash,
        });
      } else {
        this.$router.push({
          name: "photo",
          params: { ...this.$route.params, background: "" },
          query: { ...this.$route.query },
          hash: this.$route.hash,
        });
      }
    },

    isolated: function (nv, ov) {
      if (nv) {
        this.$router.push({
          name: "photo",
          params: { ...this.$route.params, background: `background-isolated` },
          query: { ...this.$route.query },
          hash: this.$route.hash,
        });
      } else {
        this.$router.push({
          name: "photo",
          params: { ...this.$route.params, background: "" },
          query: { ...this.$route.query },
          hash: this.$route.hash,
        });
      }
    },

    selectedPage: function (nv) {
      if (nv > 1) {
        this.selectedPage = nv;
        const formattedPage = `pg-${nv}`;
        this.$router.push({
          name: "photo",
          params: { ...this.$route.params, page: formattedPage },
          query: { ...this.$route.query },
          hash: this.$route.hash,
        });
      } else {
        this.$router.push({
          name: "photo",
          params: { ...this.$route.params, page: "" },
          query: { ...this.$route.query },
          hash: this.$route.hash,
        });
      }
    },

    selectedSortBy: function (nv) {
      if (nv !== "popular") {
        setTimeout(() => {
          this.$router.push({
            name: "photo",
            params: { ...this.$route.params, sort: `sort-by-${nv}` },
            query: { ...this.$route.query },
            hash: this.$route.hash,
          });
        }, 200);
      } else {
        setTimeout(() => {
          this.$router.push({
            name: "photo",
            params: { ...this.$route.params, sort: "" },
            query: { ...this.$route.query },
            hash: this.$route.hash,
          });
        }, 200);
      }
    },

    selectedResolution: function (nv, ov) {
      const resolution = nv.map((r) => r.split(" ").join("+")).join(",");
      setTimeout(() => {
        this.$router.push({
          name: "photo",
          params: {
            ...this.$route.params,
            resolution: `resolution-${resolution}`,
          },
          query: { ...this.$route.query },
          hash: this.$route.hash,
        });
      }, 300);
    },

    selectedSubCategory: function (nv, ov) {
      if (nv.length > 2) {
        const subCategory = nv.split(" ").join("-");
        this.$router.push({
          name: "photo",
          params: { ...this.$route.params, subCategory },
          query: { ...this.$route.query },
          hash: this.$route.hash,
        });
        this.selectedPage = 1;
      }
    },

    $route(to, from) {
      if (to.name === "photo") {
        this.handleFetchProducts();

        if (to.query.search) {
          this.searchQuery = to.query.search;
        } else {
          this.searchQuery = "";
        }

        if (to.params.looped) {
          this.looped = true;
        } else {
          this.looped = false;
        }

        if (to.params.background && to.params.background.includes("isolated")) {
          this.isolated = true;
        } else {
          this.isolated = false;
        }

        if (to.params.background && to.params.background.includes("blurred")) {
          this.blurred = true;
        } else {
          this.blurred = false;
        }

        if (to.params.alphaChannel) {
          this.alphaChannel = true;
        } else {
          this.alphaChannel = false;
        }

        if (to.params.subCategory) {
          this.selectedSubCategory = to.params.subCategory
            .toLowerCase()
            .split("-")
            .join(" ");
        } else {
          this.selectedSubCategory = "";
        }

        if (this.$route.params.resolution) {
          let temp = {
            all: false,
            hd: false,
            fullHd: false,
            twoK: false,
            uhd: false,
          };
          const array = this.$route.params.resolution
            .split("resolution-")[1]
            .split(",")
            .map((r) => r.split("+").join(" "));
          if (array.length < 4) {
            array.forEach((v) => {
              if (v === "720p (HD)") {
                temp.hd = true;
              }
              if (v === "1080p (Full HD)") {
                temp.fullHd = true;
              }
              if (v === "2K") {
                temp.twoK = true;
              }
              if (v === "4K (UHD)") {
                temp.uhd = true;
              }
            });

            this.minimumResolution = temp;
          } else {
            temp.all = true;
            temp.hd = true;
            temp.fullHd = true;
            temp.twoK = true;
            temp.uhd = true;
            this.minimumResolution = temp;
          }
        } else {
          this.minimumResolution = {
            all: true,
            hd: true,
            fullHd: true,
            twoK: true,
            uhd: true,
          };
        }
      }
    },

    filterToggle: function (nv, ov) {
      if (nv) {
        setTimeout(() => {
          this.sliderShow = true;
        }, 300);
      } else {
        this.sliderShow = false;
      }
    },
  },
};
</script>
<style scoped>
.inset-shadow {
  background: #eeeeee;
  box-shadow: inset 2px 2px 3px #e2e2e2, inset -4px -4px 7px #ececec;
}

.overlay-image {
  background: rgb(243, 244, 246);
  background: linear-gradient(
    0deg,
    rgba(243, 244, 246, 1) 0%,
    rgba(229, 231, 235, 0) 42%
  );
}

.pattern {
  background-color: #181818;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100%25'%3E%3Cdefs%3E%3ClinearGradient id='a' gradientUnits='userSpaceOnUse' x1='0' x2='0' y1='0' y2='100%25' gradientTransform='rotate(0,842,429)'%3E%3Cstop offset='0' stop-color='%23181818'/%3E%3Cstop offset='1' stop-color='%23404040'/%3E%3C/linearGradient%3E%3Cpattern patternUnits='userSpaceOnUse' id='b' width='436' height='363.3' x='0' y='0' viewBox='0 0 1080 900'%3E%3Cg fill-opacity='0.1'%3E%3Cpolygon fill='%23444' points='90 150 0 300 180 300'/%3E%3Cpolygon points='90 150 180 0 0 0'/%3E%3Cpolygon fill='%23AAA' points='270 150 360 0 180 0'/%3E%3Cpolygon fill='%23DDD' points='450 150 360 300 540 300'/%3E%3Cpolygon fill='%23999' points='450 150 540 0 360 0'/%3E%3Cpolygon points='630 150 540 300 720 300'/%3E%3Cpolygon fill='%23DDD' points='630 150 720 0 540 0'/%3E%3Cpolygon fill='%23444' points='810 150 720 300 900 300'/%3E%3Cpolygon fill='%23FFF' points='810 150 900 0 720 0'/%3E%3Cpolygon fill='%23DDD' points='990 150 900 300 1080 300'/%3E%3Cpolygon fill='%23444' points='990 150 1080 0 900 0'/%3E%3Cpolygon fill='%23DDD' points='90 450 0 600 180 600'/%3E%3Cpolygon points='90 450 180 300 0 300'/%3E%3Cpolygon fill='%23666' points='270 450 180 600 360 600'/%3E%3Cpolygon fill='%23AAA' points='270 450 360 300 180 300'/%3E%3Cpolygon fill='%23DDD' points='450 450 360 600 540 600'/%3E%3Cpolygon fill='%23999' points='450 450 540 300 360 300'/%3E%3Cpolygon fill='%23999' points='630 450 540 600 720 600'/%3E%3Cpolygon fill='%23FFF' points='630 450 720 300 540 300'/%3E%3Cpolygon points='810 450 720 600 900 600'/%3E%3Cpolygon fill='%23DDD' points='810 450 900 300 720 300'/%3E%3Cpolygon fill='%23AAA' points='990 450 900 600 1080 600'/%3E%3Cpolygon fill='%23444' points='990 450 1080 300 900 300'/%3E%3Cpolygon fill='%23222' points='90 750 0 900 180 900'/%3E%3Cpolygon points='270 750 180 900 360 900'/%3E%3Cpolygon fill='%23DDD' points='270 750 360 600 180 600'/%3E%3Cpolygon points='450 750 540 600 360 600'/%3E%3Cpolygon points='630 750 540 900 720 900'/%3E%3Cpolygon fill='%23444' points='630 750 720 600 540 600'/%3E%3Cpolygon fill='%23AAA' points='810 750 720 900 900 900'/%3E%3Cpolygon fill='%23666' points='810 750 900 600 720 600'/%3E%3Cpolygon fill='%23999' points='990 750 900 900 1080 900'/%3E%3Cpolygon fill='%23999' points='180 0 90 150 270 150'/%3E%3Cpolygon fill='%23444' points='360 0 270 150 450 150'/%3E%3Cpolygon fill='%23FFF' points='540 0 450 150 630 150'/%3E%3Cpolygon points='900 0 810 150 990 150'/%3E%3Cpolygon fill='%23222' points='0 300 -90 450 90 450'/%3E%3Cpolygon fill='%23FFF' points='0 300 90 150 -90 150'/%3E%3Cpolygon fill='%23FFF' points='180 300 90 450 270 450'/%3E%3Cpolygon fill='%23666' points='180 300 270 150 90 150'/%3E%3Cpolygon fill='%23222' points='360 300 270 450 450 450'/%3E%3Cpolygon fill='%23FFF' points='360 300 450 150 270 150'/%3E%3Cpolygon fill='%23444' points='540 300 450 450 630 450'/%3E%3Cpolygon fill='%23222' points='540 300 630 150 450 150'/%3E%3Cpolygon fill='%23AAA' points='720 300 630 450 810 450'/%3E%3Cpolygon fill='%23666' points='720 300 810 150 630 150'/%3E%3Cpolygon fill='%23FFF' points='900 300 810 450 990 450'/%3E%3Cpolygon fill='%23999' points='900 300 990 150 810 150'/%3E%3Cpolygon points='0 600 -90 750 90 750'/%3E%3Cpolygon fill='%23666' points='0 600 90 450 -90 450'/%3E%3Cpolygon fill='%23AAA' points='180 600 90 750 270 750'/%3E%3Cpolygon fill='%23444' points='180 600 270 450 90 450'/%3E%3Cpolygon fill='%23444' points='360 600 270 750 450 750'/%3E%3Cpolygon fill='%23999' points='360 600 450 450 270 450'/%3E%3Cpolygon fill='%23666' points='540 600 630 450 450 450'/%3E%3Cpolygon fill='%23222' points='720 600 630 750 810 750'/%3E%3Cpolygon fill='%23FFF' points='900 600 810 750 990 750'/%3E%3Cpolygon fill='%23222' points='900 600 990 450 810 450'/%3E%3Cpolygon fill='%23DDD' points='0 900 90 750 -90 750'/%3E%3Cpolygon fill='%23444' points='180 900 270 750 90 750'/%3E%3Cpolygon fill='%23FFF' points='360 900 450 750 270 750'/%3E%3Cpolygon fill='%23AAA' points='540 900 630 750 450 750'/%3E%3Cpolygon fill='%23FFF' points='720 900 810 750 630 750'/%3E%3Cpolygon fill='%23222' points='900 900 990 750 810 750'/%3E%3Cpolygon fill='%23222' points='1080 300 990 450 1170 450'/%3E%3Cpolygon fill='%23FFF' points='1080 300 1170 150 990 150'/%3E%3Cpolygon points='1080 600 990 750 1170 750'/%3E%3Cpolygon fill='%23666' points='1080 600 1170 450 990 450'/%3E%3Cpolygon fill='%23DDD' points='1080 900 1170 750 990 750'/%3E%3C/g%3E%3C/pattern%3E%3C/defs%3E%3Crect x='0' y='0' fill='url(%23a)' width='100%25' height='100%25'/%3E%3Crect x='0' y='0' fill='url(%23b)' width='100%25' height='100%25'/%3E%3C/svg%3E");
  background-attachment: fixed;
  background-size: cover;
}
</style>
